<template>
    <div class="event-settings-node mt-3">
        <h6 class="section-title">{{ $t('nodeSettings') }}</h6>

        <div v-for="setting in settingsDef" :key="setting.name" class="mb-3">
            <b-form-group
                :label="resolveLabel(setting.label, setting.name)"
                :label-for="'esetting-' + setting.name"
                label-size="sm"
                :description="resolveLabel(setting.description, '')"
            >
                <!-- String input -->
                <b-form-input
                    v-if="setting.type === 'string'"
                    :id="'esetting-' + setting.name"
                    v-model="localSettings[setting.name]"
                    :placeholder="setting.default"
                    @input="emit"
                />

                <!-- Number input -->
                <b-form-input
                    v-else-if="setting.type === 'number'"
                    :id="'esetting-' + setting.name"
                    v-model.number="localSettings[setting.name]"
                    type="number"
                    :placeholder="setting.default"
                    @input="emit"
                />

                <!-- Text area -->
                <b-form-textarea
                    v-else-if="setting.type === 'text'"
                    :id="'esetting-' + setting.name"
                    v-model="localSettings[setting.name]"
                    rows="3"
                    :placeholder="setting.default"
                    @input="emit"
                />

                <!-- Boolean toggle -->
                <c-switch
                    v-else-if="setting.type === 'boolean'"
                    :id="'esetting-' + setting.name"
                    v-model="localSettings[setting.name]"
                    color="success"
                    variant="pill"
                    :label="true"
                    dataOn="Yes"
                    dataOff="No"
                    @change="emit"
                />

                <!-- Select dropdown -->
                <v-select
                    v-else-if="setting.type === 'select' && setting.options"
                    :id="'esetting-' + setting.name"
                    v-model="localSettings[setting.name]"
                    :options="formatOptions(setting.options)"
                    label="label"
                    :reduce="option => option.value"
                    :placeholder="setting.default"
                    @input="emit"
                />

                <!-- Default: string input -->
                <b-form-input
                    v-else
                    :id="'esetting-' + setting.name"
                    v-model="localSettings[setting.name]"
                    :placeholder="setting.default"
                    @input="emit"
                />

                <small v-if="setting.required" class="text-danger">*</small>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import VSelect from 'vue-select'

export default {
    components: {
        VSelect
    },
    props: {
        value: {
            type: Object,
            default: function() { return {}; }
        },
        settingsDef: {
            type: Array,
            default: function() { return []; }
        }
    },
    data() {
        return {
            localSettings: {}
        };
    },
    watch: {
        value: {
            immediate: true,
            handler: function(val) {
                this.localSettings = Object.assign({}, val || {});
            }
        }
    },
    methods: {
        resolveLabel: function(labelObj, fallback) {
            if (!labelObj) return fallback || '';
            if (typeof labelObj === 'string') return labelObj;
            if (typeof labelObj === 'object' && labelObj.locales) {
                var locale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : 'en_US';
                var translated = labelObj.locales[locale];
                if (!translated && locale !== 'en_US') {
                    translated = labelObj.locales['en_US'];
                }
                if (!translated) {
                    var keys = Object.keys(labelObj.locales);
                    if (keys.length > 0) translated = labelObj.locales[keys[0]];
                }
                return translated || fallback || '';
            }
            return fallback || '';
        },
        emit: function() {
            this.$emit('input', Object.assign({}, this.localSettings));
        },
        formatOptions: function(options) {
            if (!Array.isArray(options)) return [];
            if (options.length === 0) return [];
            if (typeof options[0] === 'string') return options;
            return options.map(function(opt) {
                return { label: opt.label || opt.value, value: opt.value };
            });
        }
    }
};
</script>

<style scoped>
.section-title {
    font-size: 0.85rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
</style>
